import CompanyDesktopMeals from "./desktop/screens/CompanyDesktopMeals.vue";
import CompanyDesktopMealEmployees from "./desktop/screens/CompanyDesktopMealEmployees.vue";
import CompanyDesktopEmployees from "./desktop/screens/CompanyDesktopEmployees.vue";
import CompanyDesktopOrdered from "./desktop/screens/CompanyDesktopOrdered.vue";
import CompanyDesktopReserved from "./desktop/screens/CompanyDesktopReserved.vue";
import CompanyDesktopTakenMeals from "./desktop/screens/CompanyDesktopTakenMeals.vue";
import CompanyDesktopTaken from "./desktop/screens/CompanyDesktopTaken.vue";
import CompanyDesktopTakenCompany from "./desktop/screens/CompanyDesktopTakenCompany.vue";
import CompanyDesktopGroupEmployees from "./desktop/screens/CompanyDesktopGroupEmployees.vue";
import CompanyDesktopGroupOrdered from "./desktop/screens/CompanyDesktopGroupOrdered.vue";
import CompanyDesktopGroupOrderers from "./desktop/screens/CompanyDesktopGroupOrderers.vue";
import CompanyDesktopGroupGrouped from "./desktop/screens/CompanyDesktopGroupGrouped.vue";
import CompanyDesktopMultiMeals from "./desktop/screens/multi/CompanyDesktopMultiMeals.vue";
import CompanyDesktopMultiRestaurantMeals from "./desktop/screens/multi/CompanyDesktopMultiRestaurantMeals.vue";
import CompanyDesktopMultiPackages from "./desktop/screens/multi/CompanyDesktopMultiPackages.vue";
import CompanyDesktopMultiEmployees from "./desktop/screens/multi/CompanyDesktopMultiEmployees.vue";
import CompanyDesktopMultiEmployeeMealSummary from "./desktop/screens/multi/CompanyDesktopMultiEmployeeMealSummary.vue";
import CompanyDesktopMultiRestaurantSummary from "./desktop/screens/multi/CompanyDesktopMultiRestaurantSummary.vue";
import CompanyDesktopMultiCreditUsers from "./desktop/screens/multi/CompanyDesktopMultiCreditUsers.vue";
import CompanyDesktopMultiTopup from "./desktop/screens/multi/CompanyDesktopMultiTopup.vue";
import CompanyDesktopMultiCreditTopups from "./desktop/screens/multi/CompanyDesktopMultiCreditTopups.vue";

/**
 * Izveštaji firme na računaru (ključevi isti kao na telefonu, pa ?r=taken radi svuda).
 *   shifts:     izbor smena u traci odnosi se na izveštaj
 *   noExport:   izveštaj nema štampu ni Excel (stari tab ih nema)
 *   search:     false sakriva polje pretrage (izveštaj ga ne koristi)
 *   usersFeed:  ekran dobija radnike (`users`, `loading`) od ljuske umesto da ih sam učitava
 *   noCompanies: izveštaj ne zavisi od izbora firmi/restorana, pa ga traka ne nudi
 *   userPreselect: ekran dobija `preselectedUserId` (korisnik izabran u drugom izveštaju)
 * Ekrani dobijaju prop/atribut `shifts` samo kad ga koriste, a period, firme i pretragu čitaju iz store-a.
 * Obična firma, firma tipa "grupa", firma "više restorana" i stranica "Izveštaj kantina" imaju svoje skupove izveštaja
 * (`variant`). Kod firme "više restorana" su "firme" restorani, a smene čitaju stari tabovi iz store-a.
 */
export const buildCompanyDesktopScreens = (t, variant = "plain") => {
  if (variant === "multi") {
    return {
      meals: { title: t("meals"), icon: "mdi-silverware-fork-knife", component: CompanyDesktopMultiMeals, shifts: true },
      restaurantMeals: { title: t("restaurant_meals"), icon: "mdi-package-variant", component: CompanyDesktopMultiRestaurantMeals, shifts: true },
      packing: { title: t("pak"), icon: "mdi-shopping-outline", component: CompanyDesktopMultiPackages },
      employees: { title: t("employees"), icon: "mdi-account-outline", component: CompanyDesktopMultiEmployees, shifts: true },
      employeeMealSummary: { title: t("employee_meal_summary"), icon: "mdi-account-cash-outline", component: CompanyDesktopMultiEmployeeMealSummary },
      restaurantSummary: { title: t("restaurant_summary"), icon: "mdi-chart-bar", component: CompanyDesktopMultiRestaurantSummary },
      creditUsers: { title: t("credit_users"), icon: "mdi-account-cash-outline", component: CompanyDesktopMultiCreditUsers, search: false },
      addCredit: {
        title: t("add_credit"),
        icon: "mdi-cash-plus",
        component: CompanyDesktopMultiTopup,
        search: false,
        noExport: true,
        userPreselect: true,
        noCompanies: true,
        // Unos, a ne izveštaj: nema trake sa periodom, a podnaslov je kratak opis umesto perioda.
        noBar: true,
        hint: t("company_report.topup.hint"),
      },
      creditTopups: { title: t("credit_topups"), icon: "mdi-credit-card-check-outline", component: CompanyDesktopMultiCreditTopups, search: false, noCompanies: true },
    };
  }
  if (variant === "group") {
    return {
      groupUsers: { title: t("user_overview"), icon: "mdi-account-settings", component: CompanyDesktopGroupEmployees, usersFeed: true },
      groupOrdered: { title: t("ordered_1"), icon: "mdi-grid", component: CompanyDesktopGroupOrdered },
      groupOrderers: { title: t("orderers"), icon: "mdi-format-list-bulleted-type", component: CompanyDesktopGroupOrderers },
      groupGrouped: { title: t("groups_meal"), icon: "mdi-food", component: CompanyDesktopGroupGrouped, shifts: true, search: false },
    };
  }
  const plain = {
    meals: { title: t("meals"), icon: "mdi-clipboard-list-outline", component: CompanyDesktopMeals, shifts: true },
    mealEmployees: { title: t("meal_worker"), icon: "mdi-format-list-bulleted-type", component: CompanyDesktopMealEmployees },
    employees: { title: t("employees"), icon: "mdi-account-outline", component: CompanyDesktopEmployees },
    ordered: { title: t("ordered_1"), icon: "mdi-grid", component: CompanyDesktopOrdered, shifts: true },
    reserved: { title: t("r_o"), icon: "mdi-archive-outline", component: CompanyDesktopReserved, noExport: true },
    takenMeals: { title: t("t_o"), icon: "mdi-check-circle-outline", component: CompanyDesktopTakenMeals, shifts: true },
    taken: { title: t("taken"), icon: "mdi-truck-outline", component: CompanyDesktopTaken, shifts: true },
    takenCompany: { title: t("company_report.taken_company"), icon: "mdi-domain", component: CompanyDesktopTakenCompany, shifts: true },
  };
  return variant === "canteen" ? { employees: plain.employees, takenMeals: plain.takenMeals } : plain;
};
